module.exports = __webpack_public_path__ + "static/media/filled_bar.50277368.svg";